import { useNFTBalances } from 'react-moralis';
import { useEffect, useState } from 'react';
import { BREAKER_CONTRACT_ADDRESS } from '../utils/abi_contract';
import { routes } from '../routing/routes';
import { useUser } from './useUser';
import { getMoralisNetworkChain } from '../utils/contract';

/* eslint-disable react-hooks/exhaustive-deps */
export const useBreakerData = () => {
  const { logout, moralis } = useUser();
  const { isAuthenticated, user, Moralis, setUserData } = moralis;
  const { getNFTBalances } = useNFTBalances();
  const [totalBreakers, setTotalBreakers] = useState(0);
  const [myBreakers, setMyBreakers] = useState([]);
  const [selectedBreaker, setSelectedBreaker] = useState(null);
  const [isLoadingBreakerData, setIsLoadingBreakerData] = useState(true);

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', async () => {
        setSelectedBreaker(null);
        logout(routes.home());
      });
    }
  }, []);

  const setSelectedBreakerMoralis = async (breaker) => {
    await setUserData({
      selectedBreaker: JSON.stringify(breaker),
    });
    await getSelectedBreakerMoralis();
  };

  const getSelectedBreakerMoralis = async () => {
    try {
      const Breaker = Moralis.Object.extend('User');
      const query = new Moralis.Query(Breaker);
      query.equalTo('ethAddress', getEthString());
      const results = await query.find();
      console.log('Successfully retrieved ' + results.length + ' breakers.');
      if (results[0]) {
        if (results[0].get('selectedBreaker')) {
          let returnBreaker = {};
          returnBreaker = JSON.parse(results[0].get('selectedBreaker'));
          console.log('We will SET a breaker');
          setSelectedBreaker(returnBreaker);
          window.duskbreakers.selectedBreaker = returnBreaker;
          window.duskbreakers.selectedBreaker.attributes = JSON.stringify(returnBreaker.attributes);
          await getBreakerStats(returnBreaker);
          return returnBreaker;
        } else {
          console.log('No breaker currently selected for account');
          return {};
        }
      } else {
        console.log('No account matching given eth string');
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  };

  const getEthString = () => {
    return user.attributes.ethAddress;
  };

  const setPlayFabDisplayName = (name) => {
    setUserData({
      playFabDisplayName: JSON.stringify(name),
    });
    window.duskbreakers.playFabDisplayName = name;
    //disabled = {isUserUpdating}
  };

  const getPlayFabDisplayName = async (ethStr) => {
    try {
      console.log('Running getPlayFabDisplayName');
      const Breaker = Moralis.Object.extend('User');
      const query = new Moralis.Query(Breaker);
      query.equalTo('ethAddress', ethStr);
      console.log(ethStr);
      const results = await query.find();
      console.log('QUERIED');
      console.log(results);
      console.log('Successfully retrieved ' + results.length + ' breakers for PlayFab Name.');
      if (results[0]) {
        window.duskbreakers.retrievedDisplayName = JSON.parse(results[0].get('playFabDisplayName'));
        return window.duskbreakers.retrievedDisplayName;
      } else {
        console.log('No account matching given eth string');
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  };

  const setPlayFabID = (pID) => {
    setUserData({
      playFabID: JSON.stringify(pID),
    });
    window.duskbreakers.playFabID = pID;
    //disabled = {isUserUpdating}
  };

  const getPlayFabInfo = async () => {
    try {
      const Breaker = Moralis.Object.extend('User');
      const query = new Moralis.Query(Breaker);
      query.equalTo('ethAddress', getEthString());
      const results = await query.find();
      console.log('Successfully retrieved ' + results.length + ' breakers for PlayFab info.');
      if (results[0]) {
        let returnID = {};
        returnID = JSON.stringify(results[0].get('playFabID'));
        window.duskbreakers.playFabID = returnID;
        window.duskbreakers.playFabDisplayName = results[0].get('playFabDisplayName');
        return returnID;
      } else {
        console.log('No account matching given eth string');
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  };

  const initBreakerStats = async (breaker) => {
    console.log('Making breaker profile for breaker #' + breaker.token_id);
    const Breaker = Moralis.Object.extend('BreakerStats');
    const breakerStat = new Breaker();
    breakerStat.set('token_id', breaker.token_id);
    breakerStat.set('BreakerData', breaker);
    const ownerArray = [];
    ownerArray.push(user.attributes.ethAddress);
    breakerStat.set('OwnerList', ownerArray);
    breakerStat.save();
  };

  const getBreakerStats = async (breaker) => {
    try {
      const Breaker = Moralis.Object.extend('BreakerStats');
      const query = new Moralis.Query(Breaker);
      query.equalTo('token_id', breaker.token_id);
      const results = await query.find();
      console.log('Successfully retrieved ' + results.length + ' breaker profile.');
      if (results[0]) {
        window.duskbreakers.selectedBreaker.stats = {};
        window.duskbreakers.selectedBreaker.stats.rarityRanking = results[0].get('RarityRanking');
        window.duskbreakers.selectedBreaker.stats.highScores = JSON.stringify(
          results[0].get('high_scores'),
        );
        window.duskbreakers.selectedBreaker.stats.bossScores = JSON.stringify(
          results[0].get('boss_scores'),
        );
        window.duskbreakers.selectedBreaker.stats.gribbleKills = JSON.stringify(
          results[0].get('gribble_kills'),
        );
        let ownerArray = results[0].get('OwnerList');
        if (!ownerArray) {
          ownerArray = [];
        }
        if (!ownerArray.includes(user.attributes.ethAddress)) {
          console.log('Adding eth string to owner list');
          ownerArray.push(user.attributes.ethAddress);
          results[0].set('OwnerList', ownerArray);
          results[0].save();
        }
        window.duskbreakers.selectedBreaker.stats.ownerList = JSON.stringify(ownerArray);
      } else {
        console.log('No account matching given token id ' + breaker.token_id);
        await initBreakerStats(breaker);
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  };

  const refreshBreakerStats = async (token_id) => {
    try {
      const Breaker = Moralis.Object.extend('BreakerStats');
      const query = new Moralis.Query(Breaker);
      query.equalTo('token_id', token_id);
      const results = await query.find();
      console.log('Successfully retrieved ' + results.length + ' breaker stats.');
      if (results[0]) {
        window.duskbreakers.selectedBreaker.stats.highScores = JSON.stringify(
          results[0].get('high_scores'),
        );
        window.duskbreakers.selectedBreaker.stats.bossScores = JSON.stringify(
          results[0].get('boss_scores'),
        );
        window.duskbreakers.selectedBreaker.stats.gribbleKills = JSON.stringify(
          results[0].get('gribble_kills'),
        );
      } else {
        console.log('No account matching given token id ' + token_id);
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  };

  const updateBreakerStats = async (tokenID, statName, value) => {
    try {
      const Breaker = Moralis.Object.extend('BreakerStats');
      const query = new Moralis.Query(Breaker);
      query.equalTo('token_id', tokenID);
      const results = await query.find();
      console.log(
        'Successfully retrieved ' + results.length + ' breaker profile for updating stats.',
      );
      if (results[0]) {
        let statObj;

        if (statName === 'gribble_kills') {
          console.log('Updating gribble kills');
          statObj = results[0].get('gribble_kills');
          if (!statObj) {
            statObj = {};
          }
          statObj[user.attributes.ethAddress] = value;
          results[0].set('gribble_kills', statObj);
          results[0].save();
          window.duskbreakers.selectedBreaker.stats.gribbleKills = statObj;
        } else if (statName === 'high_scores') {
          console.log('Updating high scores');
          statObj = results[0].get('high_scores');
          if (!statObj) {
            statObj = {};
          }
          statObj[user.attributes.ethAddress] = value;
          results[0].set('high_scores', statObj);
          results[0].save();
          window.duskbreakers.selectedBreaker.stats.highScores = statObj;
        } else if (statName === 'boss_scores') {
          console.log('Updating boss scores');
          statObj = results[0].get('boss_scores');
          if (!statObj) {
            statObj = {};
          }
          statObj[user.attributes.ethAddress] = value;
          results[0].set('boss_scores', statObj);
          results[0].save();
          window.duskbreakers.selectedBreaker.stats.bossScores = statObj;
        } else console.log('NO STAT ASSOCIATED WITH ' + statName);
      } else {
        console.log('No account matching given token id ' + tokenID);
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  };

  const getNFTsOfUser = async () => {
    const options = {
      chain: getMoralisNetworkChain(),
      address: user.attributes.ethAddress,
      token_address: BREAKER_CONTRACT_ADDRESS,
    };
    await Moralis.Web3API.account.getNFTsForContract(options).then(
      async (value) => {
        const breakers = value.result.filter(
          (nft) =>
            nft.token_address.toLocaleLowerCase() === BREAKER_CONTRACT_ADDRESS.toLocaleLowerCase(), // NFT token address is in lower case
        );
        let fixedBreakers = [];

        // Moralis sometimes returns bad metadata so let's fix it
        for (let breaker of breakers) {
          const response = await fetch(breaker.token_uri);
          breaker.metadata = await response.json();
          breaker.image = breaker.metadata.image;
          breaker.attributes = breaker.metadata.attributes;
          fixedBreakers.push(breaker);
        }
        setMyBreakers(fixedBreakers);
        setTotalBreakers(fixedBreakers.length);
        window.duskbreakers.myBreakers = fixedBreakers;
      },
      (reason) => {
        console.error(reason);
      },
    );
  };

  const setupDuskbreakersData = async () => {
    window.duskbreakers = {};
    await getNFTsOfUser();
    window.duskbreakers.breakerList = myBreakers;
    window.duskbreakers.getEth = getEthString;
    window.duskbreakers.ethString = user.attributes.ethAddress;
    window.duskbreakers.moralisUser = user;
    window.duskbreakers.setPlayFabID = setPlayFabID;
    window.duskbreakers.setPlayFabDisplayName = setPlayFabDisplayName;
    window.duskbreakers.getPlayFabDisplayName = getPlayFabDisplayName;
    window.duskbreakers.updateBreakerStats = updateBreakerStats;
    window.duskbreakers.refreshBreakerStats = refreshBreakerStats;
    await getPlayFabInfo();
    await getSelectedBreakerMoralis();
    setIsLoadingBreakerData(false);
  };

  useEffect(async () => {
    if (isAuthenticated) {
      //await getNFTsOfUser()
      await setupDuskbreakersData();
    }
  }, [user, isAuthenticated]);

  return {
    myBreakers,
    totalBreakers,
    selectedBreaker,
    setSelectedBreakerMoralis,
    getSelectedBreakerMoralis,
    getNFTBalances,
    setupDuskbreakersData,
    isLoadingBreakerData,
  };
};
